import { render, staticRenderFns } from "./Assurances.vue?vue&type=template&id=1ea9a4a4"
import script from "./Assurances.vue?vue&type=script&lang=js"
export * from "./Assurances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports